import React from "react";
import {useSelector} from "react-redux";

export default function BrandLogo({variant = "wordmark", className = "", ...props}) {
    const name = useSelector((state) => state.app.config?.["app-name"]) || "Workspace Platform";
    return (
        <span
            className={`inline-flex align-items-center justify-content-center font-bold text-primary select-none ${className}`}
            aria-label={name}
            {...props}
        >
            {variant === "mark" ? "WP" : name}
        </span>
    );
}
